import React, { Component } from "react";
import {  Feed, Input, Button, Icon,} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, downloadS3 } from "../libs/awsLib";
import { formatDateTime, formatXml } from "../libs/sharedFunctions";
import LoadingPage from "./LoadingPage"
import ErrorPage from "./ErrorPage"  
import _ from 'lodash';

export default class SmartDeviceLog extends Component {
  constructor(props) {
    super(props);
    this.state={deviceLog: [], isLoading: true, logFilter: ""};

  }

  loadDeviceLog(smartdeviceid) {
    
    //get view data    
    invokeApig({path: '/api/smartdevices/' +smartdeviceid+'/smartdevicelogs' , method: "GET"}).then((result)=>{
      
      if(result.status===200) 
      {
        this.setState({isLoading: false, log: _.sortBy(result.data, ['logdatetime'], ['desc']), loadError: false})
      }  
      else if (result.status===404)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Page not found', loadErrorDetail: 'The page you requested was not found'})
      }
      else if (result.status===400)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Error loading page', loadErrorDetail: result.data})
      }    
      else if (result.status===401)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Permission denied', loadErrorDetail: 'You are not authorised to view this page'})
      }     
      else if (result.status===502)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'API Error', loadErrorDetail: 'The API returned an error'})
      }          
      else 
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Unexpected return code' + result.status, loadErrorDetail: result.data})
      }        
      
    }).catch(e=>
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'An error occurred submitting the request', loadErrorDetail: []})
      })
    
  }


  componentDidMount ()
  {
    this.loadDeviceLog(this.props.smartdeviceid)
  }

  componentWillReceiveProps(newProps)
  {
    if (newProps.smartdeviceid != this.props.smartdeviceid)
    {
      this.loadDeviceLog(newProps.smartdeviceid)
    }
  }
 
 
  render() {
    if (this.state.isLoading) 
    return (
    <LoadingPage />
    )
    else if (this.state.loadError)
    return (
      <ErrorPage visible={true} messageHeader={this.state.loadErrorHeader} messageDetail={this.state.loadErrorDetail}/>
    )
    else
    return (
    <div>
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.loadDeviceLog(this.props.smartdeviceid);}}><Icon name='refresh'/>Refresh</Button>
    <Input icon="search" placeholder="Search log ..." iconPosition="left" className="search" value={this.state.logFilter} onChange={(event, data)=>this.setState({logFilter: data.value})}  onClick={e => e.stopPropagation()}/>

    <Feed className="devicedetail">
    
    {this.state.log.map(logentry=>{
      const logText=logentry.logcode + ' '+logentry.logmeaning
      if (this.state.logFilter==="" || logText.toLowerCase().includes(this.state.logFilter.toLowerCase()))        
        return <Feed.Event>
        <Feed.Label icon="exclamation" />
        <Feed.Content>
        <Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>{logText}<Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>{formatDateTime(new Date(logentry.logdatetime))}</Feed.Date>
        </Feed.Summary>
        </Feed.Content>
        </Feed.Event>
    })}
    </Feed>
    </div>  
    )
  }
}